export const hero = {
  header: 'Mouthwatering home-cooked meals',
  subheader: 'Over 250 recipes a month from just £2.99 a meal*',
  benefits: '28+ veggie and 10+ vegan recipes',
}

export const PROMO_CODE_DATA = {
  defaultPromoCode: 'DTI-SB-602020',
  defaultBannerText: 'Get 60% off your first box and 20% off your first two months',
  defaultDescriptionLines: [
    `Get 60% off your first box!`,
    `Then 20% off all other boxes you order in your first two months.`,
  ],
}

export const DISCOUNT_OPTIMISATION_PROMO_CODE_DATA = {
  defaultPromoCode: 'DTI-SB-UP60',
  defaultBannerText: 'Get up to 60% off your first box and 20% off your first two months',
  defaultDescriptionLines: [
    `Get up to 60% off your first box!`,
    `Then 20% off all other boxes you order in your first two months.`,
  ],
}

export const knownVariants = ['default', 'tv']

export const defaultVariant = 'default'

export const joeWicks =
  "“I love coming home to a Gousto box with four different banging recipes each week. With so many dishes to choose from there's always something new to try!”"

export const carousel = {
  title: 'Veggie, flexi or hungry',
  subtitle:
    'There’s something for everyone on this week’s massive menu. Meals for every appetite - sorted.',
}
export const seo = {
  title: 'Recipe Boxes | Get Fresh Food & Recipes Delivered | Gousto',
  meta: [
    {
      name: 'description',
      content:
        'Change the way you eat with our easy to follow recipes. We deliver fresh boxes of ingredients and delicious recipes 7 days a week. Get started now!',
    },
    {
      name: 'keywords',
      content: 'Gousto, recipe delivery, ingredients, fresh, healthy food, cooking, recipe box',
    },
  ],
}

export const homeConfig = {
  hero,
  PROMO_CODE_DATA,
  knownVariants,
  defaultVariant,
  joeWicks,
  carousel,
  seo,
}
